// src/redux/slices/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
interface UserState {
  email: string;
  role: string;
  status: string;
  id: number;
  created_at: string;
}

const initialState: UserState = {
  email: "",
  role: "",
  status: "",
  id: 0,
  created_at: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<UserState>) => {
      return { ...state, ...action.payload };
    },
    clearUserDetails: () => initialState,
  },
});
export const getUserDetails = (state: RootState): UserState => state.user;
export const { setUserDetails, clearUserDetails } = userSlice.actions;
export default userSlice.reducer;
